var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"index"}},[_c('div',{staticClass:"main"},[_c('img',{attrs:{"src":_vm.imgUrl,"width":_vm.bannerWidth}})]),_c('bottomWrapper')],1)}
var staticRenderFns = []

export { render, staticRenderFns }